import React, {useState} from 'react';
import {NavLink} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {useAdminAuth} from './AdminAuthContext';

const {FiBarChart2, FiClipboard, FiList, FiSettings, FiUsers} = FiIcons;

const links = [
  {to: '/admin', label: 'Trips', icon: FiClipboard},
  {to: '/trip-types', label: 'Trip Types', icon: FiList},
  {to: '/admin/reservations', label: 'Reservations', icon: FiClipboard},
  {to: '/admin/reports', label: 'Reports', icon: FiBarChart2},
  {to: '/admin/waitlist', label: 'Waitlist', icon: FiUsers}
];

export default function AdminNav() {
  const {signOut} = useAdminAuth();
  const [error, setError] = useState('');

  const handleSignOut = async () => {
    setError('');
    const result = await signOut();
    if (result.error) setError(result.error.message || 'Unable to sign out.');
  };

  return (
    <div className="admin-toolbar">
      <nav className="admin-nav" aria-label="Guide navigation">
        {links.map((link) => (
          <NavLink key={link.to} to={link.to} end={link.to === '/admin'}>
            <SafeIcon icon={link.icon} />
            {link.label}
          </NavLink>
        ))}
      </nav>
      <span className="admin-setting-note">
        <SafeIcon icon={FiSettings} /> America/Los_Angeles
      </span>
      <button type="button" className="text-button" onClick={handleSignOut}>
        Sign out
      </button>
      {error && <span className="inline-message" role="status">{error}</span>}
    </div>
  );
}